import { Store } from '@betgames/bg-state-manager';
import { IDealerLobbyStoreModel } from './interfaces';

export default class DealerLobbyStore extends Store<IDealerLobbyStoreModel> {
    constructor() {
        super({
            key: 'DealerLobby',
            default: {
                dealers: [],
                dealerOptions: [],
                defaultLanguage: null,
            },
        });
    }
}

export const dealerLobbyStore = new DealerLobbyStore();
